@if(loading){
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}@else{
<form [formGroup]="defectFormGroup" [ngClass]="{'disabled': formCheck(), 'complete': defectFormGroup.get('statusId').value === 3}">
    <mat-expansion-panel togglePosition="before" [expanded]="true" class="defect-expansion-panel">
        <mat-expansion-panel-header class="header-styling">
            <mat-panel-title class="header">
                <div class="defect-header">{{defectTitle}} - {{locationSelection}}</div>
                <div class="defect-button-container">
                    <div class="fixed-icon">
                        <button type="button" (click)="fixDefect(defectFormGroup.value)" [disabled]="formCheck() || defectFormGroup.invalid" class="fix-defect-btn">
                            @if (defectFormGroup.get('statusId').value === 3) {
                                {{fixedText}}<mat-icon>check_circle</mat-icon>
                            } @else if(formCheck()) {
                                {{sentText}}
                            } @else {
                                {{fixedText}}<mat-icon>check_circle_outlined</mat-icon>
                            }
                        </button>
                    </div>
                @if(defectLengthCheck(element)) {
                    @if(closedDefect()) {
                    <button type="button" (click)="removeDefect(defectFormGroup.value)" class="remove-defect-btn">
                        <mat-icon>close</mat-icon>
                    </button>
                    }
                }
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div style="display: flex;">
            <div class="child-container">
                <div class="quantity">
                    <div class="label" style="font-weight: bold">{{locationLabel}}</div>
                    <mat-form-field class="dropdown-container-task" appearance="fill">
                        <mat-select placeholder="{{ locationPlaceholder }}" formControlName="locationId" (selectionChange)="onLocationChange($event)">
                            @for(loc of locations; track loc){
                                <mat-option [value]="loc.Id">{{ loc.Name }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="quantity">
                    <div style="font-weight: bold">{{quantityLabel}}</div>
                    <mat-form-field class="quantity-input" appearance="fill">
                        <input matInput type="number" min="0" id="quantity" (keyup)="changeQuantity(defectFormGroup.get('quantity').value, 'custom')" formControlName="quantity">
                    </mat-form-field>
                    <div class="quantity-btn-container">
                        <button class="quantity-btns" [disabled]="formCheck() || defectFormGroup.get('statusId').value === 3"
                            (click)="changeQuantity(defectFormGroup.get('quantity').value, 'add')">
                            <mat-icon style="color: black">arrow_drop_up</mat-icon>
                        </button>
                        <button class="quantity-btns" [disabled]="formCheck() || defectFormGroup.get('statusId').value === 3"
                            (click)="changeQuantity(defectFormGroup.get('quantity').value, 'subtract')">
                            <mat-icon style="color: black">arrow_drop_down</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="quantity">
                    <span class="comment-label">{{defectDescLabel}}</span>
                    <textarea class="comment-text-area" (input)="addDefectDesc($event)"
                        formControlName="defectDesc"></textarea>
                </div>
            </div>
            <div class="child-container">
                @if(closedDefect()) {
                <designate-station [isEnabled]="enableDesignation"
                    [designate]="defectFormGroup.get('designateStation').value"
                    (designationTriggered)="onDesignationTriggered($event)"></designate-station>
                } @else {
                    <div class="designation-placeholder"></div>
                }
            </div>
        </div>
    </mat-expansion-panel>
</form>
}